module.exports = __webpack_public_path__ + "static/media/navigate_before.75589b27.svg";